// GENERATED FILE - DO NOT MODIFY

export enum UpdateUserScheduleTimelineOperationDto {
    RevertPeriodToDefaultSchedule = "RevertPeriodToDefaultSchedule",
    CreateEmptyPersistedPeriod = "CreateEmptyPersistedPeriod",
}